module.exports = __webpack_public_path__ + "img/reporting_info_numbers.4fab5329.svg";